
import React, { useState, useEffect } from "react";
import "./AllPosts.css";
import { useLocation } from "react-router-dom";
import chunk from "chunk";
import TuneIcon from "@mui/icons-material/Tune";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DayPostsTable from "./DayPostsTable";
import Pagination from "../../Components/Pagination/Pagination";
import { useGlobalContext } from "../../context";

function DayPostsData() {
    
    const {
        setCategorys
    } = useGlobalContext()
    
    const location = useLocation();
    const [dayData, setDayData] = useState([]);
    const [showDayData, setShowDayData] = useState([]);
    const [chunkData, setChunkData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showFilterBox, setShowFilterBox] = useState(true);
    const [fullName, setFullName] = useState("");
    const [facebookId, setFacebookId] = useState("");
    const [status, setStatus] = useState("");
    const [showStatusBox, setShowStatusBox] = useState(false);
    const [socialMedia, setSocialMedia] = useState("");
    const [showSocialMediaBox, setShowSocialMediaBox] = useState(false);
    const [activeCategory, setActiveCategory] = useState("");
    const [sortBySocialMedia, setSortBySocialMedia] = useState();
    
    useEffect(() => {
        setDayData(location.state);
    },[location])
    
    useEffect(() => {
        setShowDayData(dayData);
    },[dayData])

    useEffect(() => {
        if (sortBySocialMedia !== undefined) {
            const faceBookPosts = showDayData.filter(item => item.socialMedia === 'FACEBOOK');
            const instaPosts = showDayData.filter(item => item.socialMedia === "INSTAGRAM");
            if (sortBySocialMedia === false) {
                setShowDayData(faceBookPosts.concat(instaPosts));
            }
            else {
                setShowDayData(instaPosts.concat(faceBookPosts));
            }
        }
        else {
            setShowDayData(dayData);
        }
    }, [sortBySocialMedia])
    
    useEffect(() => {
        setChunkData( chunk(showDayData, 100) );
    }, [showDayData])
    
    const filterUsersList = () => {
        setShowDayData(dayData);
        let data = {
            clientFullName: fullName,
            facebookProfileId: facebookId,
            status,
            socialMedia
        }
        
        for ( let key in data ) {
            if (data[key]) {
                setShowDayData(showDayData => showDayData.filter(item => {
                    if (key === "socialMedia") {
                        return item[key].toUpperCase() === data[key].toUpperCase();
                    }
                    else {
                        return item[key].includes(data[key]);
                    }
                }
                ))
            }
        }
    }
    
    const filterFromEnter = (e) => {
        if (e.key === "Enter") {
            filterUsersList();
        }
    }
    
    window.document.body.onkeydown = filterFromEnter;
    
    useEffect(() => {
        setShowDayData(dayData);
        if (activeCategory === "All") {
            setShowDayData(dayData);
        }
        else {
            setShowDayData(showDayData => showDayData.filter(item => item.category.replaceAll("_", " ").toUpperCase() === activeCategory.toUpperCase()));
        }
    }, [activeCategory])
    
    const clearFilterData = () => {
        setFullName("");
        setFacebookId("");
        setStatus("");
        setSocialMedia("");
        setShowDayData(dayData);
        setCategorys(categorys => categorys.map(ctgry => ctgry.text === "REAL ESTATE" ? { ...ctgry, active: true } : { ...ctgry, active: false }));
    }
    
    return(
        <div className = "DayPostsData">
            <div className = "filterUsersIconBox">
                <TuneIcon 
                    style = {{
                        color: "#3F68B1", 
                        margin: "0 5px", 
                        fontSize: "1.6rem", 
                        cursor: "pointer"
                    }} 
                    onClick={ () => setShowFilterBox(!showFilterBox) }
                />
                <span className = "filterUsersIconBoxText"> Filter </span>
            </div>
            <div 
                className = "filterInputsBtnsBox"
                style = {{
                    display: showFilterBox ? "flex" : "none",
                }}
            >
                <div className = "filterInputsBox">
                    <span className = "filterInputsSpan">
                        <input
                            type = "text"
                            className = "filterInput"
                            name = "Full Name"
                            placeholder = "FULL NAME"
                            value = { fullName }
                            onChange = { e => setFullName(e.target.value) }
                        />
                    </span>
                    <span className = "filterInputsSpan">
                        <input
                            type = { "text" }
                            className = "filterInput"
                            name = "Full Name"
                            placeholder = "FACEBOOK ID"
                            value = { facebookId }
                            onChange = { e => setFacebookId(e.target.value) }
                        />
                    </span>
                    <span className = "filterInputsSpan">
                        <span 
                            className = "selectBox"
                            onClick = {() => {
                               setShowStatusBox(!showStatusBox);
                               setShowSocialMediaBox(false)
                            }}
                        >
                            {
                                status ? status : "STATUS"
                            }
                            <KeyboardArrowDownIcon
                                style = {{
                                    color: "#999999", 
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                        <div 
                             className = "selectHideBox" 
                             style = {{
                                display: !showStatusBox ? "none" : "flex"
                             }}
                        >
                            <span
                                className = "selectConcretType"
                                onClick = {() => {
                                    setShowStatusBox(false);
                                    setStatus("COMPLETED");
                                }}
                            >
                                COMPLETED
                            </span>
                            <span
                                className = "selectConcretType"
                                onClick = {() => {
                                    setShowStatusBox(false);
                                    setStatus("FAILED");
                                }}
                            >
                                FAILED
                            </span>
                        </div>
                    </span>
                    <span 
                        className = "filterInputsSpan" 
                        style = {{
                            width: "250px"
                        }}
                    >
                        <span
                            className = "selectBox"
                            onClick = {() => {
                                setShowSocialMediaBox(!showSocialMediaBox);
                                setShowStatusBox(false);
                            }}
                        >
                            {
                                socialMedia ? socialMedia : "SOCIAL MEDIA"
                            }
                            <KeyboardArrowDownIcon
                                style = {{
                                    color: "#999999", 
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                        <div 
                            className = "selectHideBox" 
                            style = {{
                                display: !showSocialMediaBox ? "none" : "flex"
                            }}
                        >
                            <span 
                                className = "selectConcretType" 
                                onClick = {() => {
                                    setSocialMedia("Facebook");
                                    setShowSocialMediaBox(false);
                                }}
                            >
                                Facebook
                            </span>
                            <span 
                                className = "selectConcretType" 
                                onClick = {() => {
                                    setSocialMedia("Instagram");
                                    setShowSocialMediaBox(false);
                                }}
                            >
                                Instagram
                            </span>
                        </div>
                    </span>
                </div>
                <div className = "filterBtnsBox">
                    <button
                        className = "filterButton"
                        style = {{
                            color: fullName || facebookId || socialMedia || status ? "white" : "#3F68B1",
                            backgroundColor: fullName || facebookId || socialMedia || status ? "#3F68B1" : "#FAFAFA"
                        }}
                        onClick = { filterUsersList }
                    >
                        FILTER
                    </button>
                    <button
                        className = "clearButton"
                        style = {{
                            color: fullName || facebookId || socialMedia || status ? "#819F10" : "#929292"
                        }}
                        onClick = { clearFilterData }
                    >
                        CLEAR
                    </button>
                </div>
            </div>
            <DayPostsTable 
                tableData = { tableData }
                setActiveCategory = { setActiveCategory }
                sortBySocialMedia = { sortBySocialMedia }
                setSortBySocialMedia = { setSortBySocialMedia }
            />
            <Pagination 
                chunkData = { chunkData }
                setTableData = { setTableData }
            />
        </div>
    )
}

export default DayPostsData
